import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { __ } from '@app/shared/functions/object.functions';
import { filter, map } from 'rxjs';

@Component({
  selector: 'hypecast-admin-navigation-link',
  templateUrl: './navigation-link.component.html',
  styleUrl: './navigation-link.component.scss',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationLinkComponent {
  private readonly router = inject(Router);

  readonly link = input('');
  readonly icon = input('');
  readonly displayName = input('');
  readonly tag = input('');
  readonly externalLink = input(false);
  readonly isCollapsed = input(false);
  readonly exactMatch = input(false);

  /** Additional route prefixes that should highlight this nav link (e.g. ['video-editor', 'editor']). */
  readonly alsoActiveFor = input<string[]>([]);

  /** When true, the active highlight is never applied (e.g. for action items like 'New podcast'). */
  readonly noActiveHighlight = input(false);

  protected readonly __ = __;

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
    ),
    { initialValue: this.router.url },
  );

  readonly isAlsoActive = computed(() => {
    const additionalPrefixes = this.alsoActiveFor();
    if (additionalPrefixes.length === 0) return false;

    const url = this.currentUrl();
    return additionalPrefixes.some((prefix) => url.startsWith('/' + prefix));
  });
}
